export default __webpack_public_path__ + "static/media/trophy.89638282.svg";